export const COMMON_APP_CONFIG = 'COMMON_APP_CONFIG';
